module.exports = __webpack_public_path__ + "assets/img/i.845400bd.png";